import { NgModule } from '@angular/core';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { SharedModule } from 'shared/shared.module';

import { SliceTabsRenderComponent } from './render/slice-tabs-render.component';


export const sliceTabsRenderModuleEntryComponents = [
  SliceTabsRenderComponent,
];

@NgModule({
  imports: [
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule,
  ],
  exports: [
    sliceTabsRenderModuleEntryComponents
  ],
  declarations: sliceTabsRenderModuleEntryComponents
})
export class SliceTabsRenderModule {}

export default sliceTabsRenderModuleEntryComponents;
